import styled from 'styled-components'
import { List } from 'antd'

const AntListStyled = styled(List)`
  &&& {
    .ant-pagination-item-active {
      border-color: ${props => props.theme.colors.color1.bg};

      a {
        color: ${props => props.theme.colors.color1.bg};
      }
    }
    .ant-pagination-item {
      :focus,
      :hover {
        border-color: ${props => props.theme.colors.color1.bg};
        a {
          color: ${props => props.theme.colors.color1.bg};
        }
      }
    }
    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
      color: ${props => props.theme.colors.color1.bg};
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      :focus,
      :hover {
        .ant-pagination-item-link {
          border-color: ${props => props.theme.colors.color1.bg};
          color: ${props => props.theme.colors.color1.bg};
        }
      }
    }
  }
`

export default AntListStyled
